<template>
    <div id="bread-crumbs">
        <a :href="homeUrl">
            <img src="/img/product/home.svg" alt="Home" />
        </a>
        <span class="arrow">
            <img src="/img/product/chevron-right.svg" alt="Arrow" />
        </span>
        <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
            <a :href="breadcrumb.url" v-html="decodeHtml(capitalize(breadcrumb.label))"></a>
            <span class="arrow">
                <img src="/img/product/chevron-right.svg" alt="Arrow" />
            </span>
        </template>
        <p v-if="lastCrumb">{{ lastCrumb.label }}</p>
    </div>
</template>

<script>
export default {
    props: {
        breadcrumbs: {
            type: Array,
            required: true,
        },
        homeUrl: {
            type: String,
            default: '/',
        },
        lastCrumb: {
            type: Array,
            required: false,
        },
    },
    methods: {
        decodeHtml(html) {
            const txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        },
        capitalize(text) {
            if (!text) return '';
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
    }
};
</script>

<style scoped lang="scss">
#bread-crumbs {
    display: flex;
    align-items: center;
    gap: 5px;
    position: relative;
    z-index: 1;
    margin: 15px 0;

    a,
    router-link,
    p {
        color: #9BA1AB;
        font-family: 'Roboto-Light';
        font-weight: 100;
        line-height: 140%;
        transition: 0.3s all;
    }

    .arrow,
    a,
    router-link {
        display: flex;
        align-items: center;
        justify-content: baseline;
    }

    .arrow {
        &:last-child {
            display: none;
        }
    }

    a,
    router-link {
        &:hover {
            color: #C0C3C9;
        }
    }

    p {
        color: #9BA1AB;
    }

    @media only screen and (max-width: 767px) {
        display: none;

        >* {
            display: inline-block !important;
            line-height: 24px !important;
            margin-left: 5px;

            &:first-child {
                margin-left: 0;
            }
        }

        .arrow {
            img {
                margin-bottom: -4px;
            }
        }

        a,
        router-link {
            img {
                margin-bottom: -2px;
            }
        }
    }
}
</style>